
    var riot = require('riot')
    
riot.tag2('referee_details', '<raw content="{opts.opts.referee_details}"></raw> <ul class="nav nav-tabs"> <li each="{ref, i in opts.psedata.referees}" class="{active:parent.referee_id == i}"><a href="./referee_details/{i+1}" class="heading btn">{i+1}</a></li> <li><a onclick="{addReference}" class="btn btn-success">Add Reference</a></li> <li> <confirm onconfirm="{deleteReference}"><a class="btn btn-danger">Delete Reference</a></confirm> </li> </ul> <div class="tab-content"> <div class="tab-pane {active: referee}"> <div class="col-xs-10 col-xs-offset-1"> <form class="form-horizontal"> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <forminput name="ref_name" label="Name *" value="{referee.ref_name}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.referee.ref_name)}" isrequired></forminput> <forminput name="ref_ac_qualification" label="Academic Qualification (if known)" value="{referee.ref_ac_qualification}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.referee.ref_ac_qualification)}"></forminput> <forminput name="ref_prof_qualification" label="Professional Qualifications" value="{referee.ref_prof_qualification}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.referee.ref_prof_qualification)}"></forminput> <forminput name="ref_relationship" label="Working Relationship to Applicant *" value="{referee.ref_relationship}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.referee.ref_relationship)}" isrequired></forminput> <forminput name="ref_refaddress1" label="Address" value="{referee.ref_refaddress1}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.referee.ref_refaddress1)}"></forminput> <forminput name="ref_refaddress2" label=" " value="{referee.ref_refaddress2}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_refaddress3" label=" " value="{referee.ref_refaddress3}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_refaddress4" label=" " value="{referee.ref_refaddress4}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_refaddress5" label=" " value="{referee.ref_refaddress5}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_refpostcode" label="Zip/Post Code" value="{referee.ref_refpostcode}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_refcountry" label="Country" value="{referee.ref_refcountry}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_reftelephone" label="Telephone" value="{referee.ref_reftelephone}" onupdate="{handleUpdate}"></forminput> <forminput name="ref_refemail" label="Email *" value="{referee.ref_refemail}" onupdate="{handleUpdate}" isrequired></forminput> </form> </div> </div> </div>', '', '', function(opts) {
this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.on('update', function() {
  if (opts.psedata != null) {
    this.load();
  }
  if ((opts.errors != null) && this.mounted) {
    return this.checkErrors();
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.refereeErrors = opts.errors.filter(function(e) {
      return e.tab === 'referees';
    }).map(function(e) {
      return e.field;
    });
    _this.update();
    return _this.refereeErrors.forEach(function(field) {
      return _this.tags[field].tags['formgroup'].trigger('validate');
    });
  };
})(this);

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);

this.load = (function(_this) {
  return function() {
    var ref;
    _this.referees = opts.psedata.referees;
    _this.referee_id = opts.params.referee_id != null ? opts.params.referee_id - 1 : 0;
    if (((ref = _this.referees) != null ? ref[_this.referee_id] : void 0) != null) {
      _this.referee = _this.referees[_this.referee_id];
    }
    return _this.update();
  };
})(this);

this.addReference = function() {
  this.referees.push({});
  opts.page.redirect('referee_details/' + this.referees.length);
  return this.update();
};

this.deleteReference = (function(_this) {
  return function() {
    _this.referees.splice(_this.referee_id, 1);
    opts.page.redirect('referee_details/' + _this.referees.length);
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    _this.referee[val.name] = val.value;
    return opts.onupdate('referees', _this.referee_id, _this.referee);
  };
})(this);
});
    
  